var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$resize && _vm.$mq.above(_vm.vsize.tablet))?_c('AppHeader'):_c('MobileNav')}
var staticRenderFns = []

export { render, staticRenderFns }